export const HasComments = {

}
